export default __webpack_public_path__ + "static/media/button-arrow-blue.a6dea69e.svg";